import React, { useState } from "react";
import {
  makeStyles,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Text,
  typographyStyles,
} from "@fluentui/react-components";
import { Book20Regular, GroupListRegular, TextEffectsSparkleRegular } from "@fluentui/react-icons";
import "./OutlineControlsMode.css";

import type { OutlineMode } from "src/types";

export type MenuItemType = Record<OutlineMode, { icon?: React.ReactElement; text: string }>;

const menuItems: MenuItemType = {
  style: {
    icon: <GroupListRegular />,
    text: "Style Mode",
  },
  chapter: {
    icon: <Book20Regular />,
    text: "Chapter Mode",
  },
  character: {
    icon: <TextEffectsSparkleRegular />,
    text: "Character Mode",
  },
};

const useStyles = makeStyles({
  menuItem: {
    ...typographyStyles.caption1Stronger,
    color: "var(--colorNeutralForeground2) !important",
  },
});

export interface OutlineControlsModeProps {
  outlineMode: OutlineMode;
  onSelectOutlineMode: (outlineMode: OutlineMode) => void;
}

export function OutlineControlsMode({
  outlineMode = "style",
  ...props
}: React.PropsWithChildren<OutlineControlsModeProps>) {
  const styles = useStyles();

  const handleSelectMode = (mode: OutlineMode) => props.onSelectOutlineMode(mode);

  return (
    <Menu>
      <MenuTrigger>
        <MenuButton
          appearance="secondary"
          className="outline-controls-button"
          icon={menuItems[outlineMode].icon}
        >
          <Text>{menuItems[outlineMode].text}</Text>
        </MenuButton>
      </MenuTrigger>
      <MenuPopover>
        <MenuList className="outline-controls-menu-list">
          <MenuItem className={styles.menuItem} disabled>
            Review by...
          </MenuItem>
          {Object.entries(menuItems).map(([mode, item]) => (
            <MenuItem
              icon={item.icon}
              key={mode}
              onClick={() => handleSelectMode(mode as OutlineMode)}
            >
              {item.text}
            </MenuItem>
          ))}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
}
